import { _ } from "@sablier/v2-mixins";
import { Plugin } from "@sablier/v2-models";
import { zeroAddress } from "viem";
import type { Translate } from "@sablier/v2-locales";
import type { IAddress } from "@sablier/v2-types";
import { validateAddress } from "./address";
import policy from "./policy";

interface ProxyValidProps {
  t: Translate;
  value: IAddress | undefined;
}

export async function validateProxy({ t, value }: ProxyValidProps) {
  try {
    const address = validateAddress({ t, value });
    if (address) {
      return address;
    }

    if (_.toAddress(value) === _.toAddress(zeroAddress)) {
      return policy.proxy.missing(t);
    }
  } catch (_e) {
    return policy.proxy.missing(t);
  }
  return undefined;
}

interface PluginValidProps {
  expected?: IAddress | undefined;
  t: Translate;
  value: IAddress | undefined;
}

export async function validatePlugin({ expected, t, value }: PluginValidProps) {
  try {
    if (!Plugin.isValid({ expected, value })) {
      return policy.plugin.missing(t);
    }
  } catch (_e) {
    return policy.plugin.missing(t);
  }
  return undefined;
}
